module.exports = __webpack_public_path__ + "img/美容水(绿)_05.978221e4.jpg";